



































import { Component, Prop, Mixins } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IOrder } from "@/models/orders";
import { mapState } from "vuex";
import Context from "@/mixins/context";
import { QUERY_PARAMS } from "@/data/constants";
import { Location as VueLocation } from "vue-router";

const ORDERS_MODULE = `data/${DataModules.ORDERS}`;

@Component({
  components: {
    "pay-invoice-cta": () =>
      import("@/components/app/global/invoices/payInvoiceCta.vue")
  },
  computed: {
    ...mapState({
      isDue(state, getters) {
        return getters[`${ORDERS_MODULE}/isDue`](this.order);
      },
      isOverdue(state, getters) {
        return getters[`${ORDERS_MODULE}/isOverdue`](this.order);
      },
      isPaid(state, getters) {
        return getters[`${ORDERS_MODULE}/isPaid`](this.order);
      },
      isPartiallyPaid(state, getters) {
        return getters[`${ORDERS_MODULE}/isPartiallyPaid`](this.order);
      },
      isCancelled(state, getters) {
        return getters[`${ORDERS_MODULE}/isCancelled`](this.order);
      }
    })
  }
})
export default class OrderStatusSummary extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public order!: IOrder;

  @Prop({ default: undefined })
  public externalAuthReturnLocation!: VueLocation;

  // Data
  public isDue!: boolean;
  public isOverdue!: boolean;
  public isPaid!: boolean;
  public isPartiallyPaid!: boolean;
  public isCancelled!: boolean;
  public hasOnlineGateways = false;
  public async created() {
    try {
      this.hasOnlineGateways = await this.$store.dispatch(
        `data/${DataModules.BRAND_GATEWAYS}/hasOnline`,
        {
          brandId: this.order.brand_id
        }
      );
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }
  // Computed
  public get hasUnsuccessfulPayment() {
    return this.$route.query[QUERY_PARAMS.PAYMENT_SUCCESS] === "false";
  }

  public get hasPendingPayment() {
    return !!this.order?.payments?.find(i => i.pending);
  }

  public get messageType() {
    if (this.isPaid) return "is-success";
    if (this.hasUnsuccessfulPayment) return "is-danger";
    if (this.isCancelled) return "is-grey";
    return "is-warning";
  }

  public get messageIcon() {
    if (this.isPaid) return "check-circle";
    if (this.hasPendingPayment) return "hourglass-start";
    return "";
  }

  public get messagePath() {
    if (this.isPaid) return "_sentence.order_paid";
    if (this.hasPendingPayment) return "_sentence.order_has_pending_payment";
    if (this.hasUnsuccessfulPayment) return "_sentence.order_payment_failed";
    if (this.isPartiallyPaid) return "_sentence.order_partly_paid";
    if (!this.isAdmin && !this.hasOnlineGateways)
      return "_sentence.order_not_paid_no_gateways";
    if (this.isDue) return "_sentence.order_not_paid";
    if (this.isCancelled) return "_sentence.order_cancelled";
    return "";
  }
}
